export const slug = "compare-clients";
export const title = "Compare Clients (Duplicate Detection)";
export const section = "Core";
export const content = `
# Compare Clients

The Compare Clients page helps you identify and resolve duplicate registrations.

## How Duplicate Detection Works

The system automatically scans for potential duplicates using a combination of:

- **Name similarity** — phonetic and fuzzy matching to catch spelling variations.
- **Address match** — same street address flags possible household duplicates.
- **Phone / email match** — identical contact info across different records.

Potential duplicates appear in the **Needs Review** queue on this page.

## Side-by-Side Comparison

Click a pair from the queue to open the comparison view. Both records appear side by side with differences highlighted in yellow so you can quickly spot which record is more complete or more recent.

## Merging Records

If the two records belong to the same person:

1. Review both records in the comparison view.
2. Choose which record to **keep** (the primary) and which to **merge into it**.
3. Click **Merge** — visit history, household members, and program enrollments from the discarded record are transferred to the primary.
4. The discarded record is archived, not deleted, so the audit trail is preserved.

## Dismissing False Positives

If the two records are genuinely different people, click **Not a Duplicate**. The pair is dismissed and will not appear in the queue again. The dismissal is logged with your name and timestamp.

## Tips

- Merging cannot be undone through the UI. Double-check both records before confirming.
- If you are unsure, use the **Flag for Later** option to keep the pair in the queue for a second opinion.
`;
